import { atom } from "recoil";

export const frontEditModalState = atom<boolean>({
  key: "FrontEditModalState",
  default: false,
});
